export const ONE_HOUR = 1000 * 60 * 60;
export const TWELVE_HOURS = ONE_HOUR * 12;
